<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const isAtTop = ref(true)

function checkScroll() {
  isAtTop.value = window.scrollY === 0
  console.log(isAtTop.value)
}

function handleScroll() {
  window.scrollBy({
    top: window.innerHeight,
    behavior: 'smooth'
  });
}

onMounted(() => {
  window.addEventListener('scroll', checkScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', checkScroll)
})
</script>

<template>
<button v-if="isAtTop" v-on:click="handleScroll">
  MEER LEZEN
</button>
</template>

<style scoped>
button {
  position: fixed;
  bottom: 1rem;
  left: 50%;
  justify-self: center;
  transform: translateX(-50%);
  background-color: var(--color-primary);
  color: var(--color-text-white);
  padding: 0.5rem 1rem;
  cursor: pointer;
  z-index: 999;
}

button:hover {
  background-color: var(--color-gray-dark-stay);
}
</style>